import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { BRAND, telLink } from "@/lib/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#08080A] mt-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-md bg-white p-1.5">
              <img src={BRAND.logoUrl} alt="Secure Watch" className="h-full w-full object-contain" />
            </div>
            <div>
              <div className="font-heading font-extrabold text-white text-lg">SECURE WATCH</div>
              <div className="text-xs uppercase tracking-[0.2em] text-brand-cyan">A Smart Security Solution</div>
            </div>
          </div>
          <p className="text-white/60 text-sm mt-5 max-w-md">
            Guwahati's first dedicated online remote CCTV monitoring & surveillance company. We keep an eye
            on your home & business — every night, live from our command center.
          </p>
          <div className="flex items-center gap-2 mt-5 text-xs text-white/50">
            <ShieldCheck className="h-4 w-4 text-brand-cyan" />
            First in Guwahati · Assam-based · Trusted
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white font-semibold text-sm mb-4">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-home">Home</Link></li>
            <li><a href="/#services" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-services">Services</a></li>
            <li><a href="/#plans" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-plans">Plans & Pricing</a></li>
            <li><a href="/#how" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-how">How it Works</a></li>
            <li><a href="/#faq" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-faq">FAQ</a></li>
            <li><Link to="/contact" className="text-white/60 hover:text-brand-cyan" data-testid="footer-link-contact">Book a Free Audit</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-white font-semibold text-sm mb-4">Reach us</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-brand-cyan shrink-0" />
              <span className="text-white/70">{BRAND.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-brand-cyan" />
              <a href={telLink} className="text-white/80 hover:text-brand-cyan" data-testid="footer-phone">{BRAND.phoneDisplay}</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-red-400" />
              <a href={`tel:+91${BRAND.monitoringPhone}`} className="text-white/80 hover:text-red-400" data-testid="footer-monitoring-phone">
                {BRAND.monitoringPhoneDisplay}
                <span className="ml-1 text-[10px] uppercase tracking-widest text-red-400/80">Monitoring · SOS</span>
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-brand-cyan" />
              <a href={`mailto:${BRAND.email}`} className="text-white/80 hover:text-brand-cyan break-all" data-testid="footer-email">{BRAND.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-5">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Secure Watch — VSS Virtual Security Solutions. All rights reserved.</p>
          <p className="text-xs text-white/40">Guwahati · Assam · India</p>
        </div>
      </div>
    </footer>
  );
}
